import { render, staticRenderFns } from "./NoticeboardDisplay.vue?vue&type=template&id=8426c204&scoped=true&"
import script from "./NoticeboardDisplay.vue?vue&type=script&lang=ts&"
export * from "./NoticeboardDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeboardDisplay.vue?vue&type=style&index=0&id=8426c204&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8426c204",
  null
  
)

export default component.exports